import { useTableProvider } from "../../providers";

import { MainContentComponent, TableComponent } from "components";
import {
  HeaderLeft,
  TableItemsComponent,
  TablePaginationComponent,
  HeaderRight,
} from "..";

export function MainComponent() {
  const { isLoading } = useTableProvider();

  return (
    <MainContentComponent
      headerLeft={<HeaderLeft />}
      headerRight={<HeaderRight />}
    >
      <TableComponent>
        <thead>
          <tr>
            <th>ID</th>
            <th>Serial Number</th>
            <th>Source</th>
            <th>Total</th>
            <th>Payment Status</th>
            <th>Created At</th>
            <th></th>
          </tr>
        </thead>
        <TableComponent.Body colCount={7} isLoading={isLoading}>
          <TableItemsComponent />
        </TableComponent.Body>
        <TableComponent.Pagination>
          <TablePaginationComponent />
        </TableComponent.Pagination>
      </TableComponent>
    </MainContentComponent>
  );
}
